import { Box } from "@mui/material";

import { NewCargoBodyType } from "../../../../cargosAPI";
import { CityType } from "../../../../../cities/citiesAPI";
import { TextTitle } from "../../shared/TextTitle";
import { TextSubtitle } from "../../shared/TextSubtitle";

export const Route = ({ currentCargo }: { currentCargo: NewCargoBodyType }) => {
  const departureCity = currentCargo.cities.departure as CityType;
  const destinationCity = currentCargo.cities.destination as CityType;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 3,
      }}
    >
      <Box>
        <TextTitle label="Aeropuerto de carga" />
        <TextSubtitle
          label={`${departureCity.cityName} (${departureCity.code})`}
        />
      </Box>
      <Box>
        <TextTitle label="Aeropuerto de destino" />
        <TextSubtitle
          label={`${destinationCity.cityName} (${destinationCity.code})`}
        />
      </Box>
    </Box>
  );
};
